document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons and content containers
  const buttons = document.querySelectorAll(".information-menu-item");
  const contents = document.querySelectorAll(".information-content-container");
  const menuContainer = document.querySelector(".information-menu-container");
  const contentWrapper = document.querySelector(".information-content-wrapper");

  // Function to show a specific section
  function showSection(sectionId) {
    // Remove 'active' class from all buttons and hide all content containers
    buttons.forEach((button) => button.classList.remove("active"));
    contents.forEach((content) => {
      content.classList.add("hidden");
      content.classList.remove("active-content");
    });

    // Find and activate the button for this section
    const buttonId = sectionId + "-button";
    const button = document.getElementById(buttonId);
    if (button) {
      button.classList.add("active");
      button.style.opacity = "0.4";
    }

    // Show the corresponding content container
    const contentToShow = document.getElementById(sectionId);
    if (contentToShow) {
      contentToShow.classList.remove("hidden");
      contentToShow.classList.add("active-content");
    }
  }

  // Function to handle button clicks and toggle visibility
  function handleButtonClick(event) {
    // Get the section name from the button ID
    const contentId = event.target.id.replace("-button", "");

    // Update the URL with the section
    const newUrl = window.location.pathname + "#" + contentId;
    history.pushState({ section: contentId }, "", newUrl);

    // Show the selected section
    showSection(contentId);
  }

  // Function to handle mouse enter for a specific button
  function handleMouseEnter(event) {
    const hoveredButton = event.target;
    const activeButton = document.querySelector(
      ".information-menu-item.active"
    );

    // If the hovered button is the active button, set its opacity to 1
    if (activeButton && activeButton === hoveredButton) {
      hoveredButton.style.opacity = "1";
    } else {
      hoveredButton.style.opacity = "0.4";

      // Ensure the active button has full opacity while hovering over other buttons
      if (activeButton) {
        activeButton.style.opacity = "1";
      }
    }
  }

  // Function to handle mouse leave for a specific button
  function handleMouseLeave(event) {
    const hoveredButton = event.target;
    const activeButton = document.querySelector(
      ".information-menu-item.active"
    );

    if (activeButton && activeButton === hoveredButton) {
      hoveredButton.style.opacity = "0.4";
    } else if (activeButton) {
      activeButton.style.opacity = "0.4";
    }

    // Reset the hovered button to full opacity if it was not active
    if (!hoveredButton.classList.contains("active")) {
      hoveredButton.style.opacity = "1";
    }
  }

  // Add click and hover event listeners to each button
  buttons.forEach((button) => {
    button.addEventListener("click", handleButtonClick);
    button.addEventListener("mouseenter", handleMouseEnter);
    button.addEventListener("mouseleave", handleMouseLeave);
  });

  // Handle browser back/forward buttons
  window.addEventListener("popstate", function (event) {
    if (event.state && event.state.section) {
      showSection(event.state.section);
    } else {
      // If no state, check the hash in URL
      const hash = window.location.hash.substring(1);
      if (hash) {
        showSection(hash);
      } else {
        showSection("biography");
      }
    }
  });

  // Initial state setup: Check URL for section on page load
  const hash = window.location.hash.substring(1); // Get hash without the '#'
  if (hash && document.getElementById(hash)) {
    // Show the section from the URL hash
    showSection(hash);
    // Update history state
    history.replaceState({ section: hash }, "", window.location.href);
  } else {
    // Default to biography if no valid hash
    showSection("biography");
    history.replaceState(
      { section: "biography" },
      "",
      window.location.pathname + "#biography"
    );
  }

  // CONTACT — click or tap the address to copy it. The label crossfades to
  // COPIED and back after COPIED_MS. The hover dim is CSS and desktop-only
  // (style-page.css.liquid); this owns only the copy and the .is-copied state.
  const contact = document.querySelector(".information-contact");
  if (contact) {
    const COPIED_MS = 1500;
    let copiedTimer = null;

    const copyText = (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
      // Fallback for older Safari / any non-secure context: execCommand can
      // only copy a live selection, so it needs a real field to select from.
      return new Promise((resolve, reject) => {
        const buffer = document.createElement("textarea");
        buffer.value = text;
        buffer.setAttribute("readonly", "");
        buffer.className = "information-copy-buffer";
        document.body.appendChild(buffer);
        buffer.select();
        buffer.setSelectionRange(0, text.length); // iOS ignores select() alone
        const copied = document.execCommand("copy");
        buffer.remove();
        copied ? resolve() : reject(new Error("copy failed"));
      });
    };

    const handleCopy = () => {
      const source = contact.querySelector(".information-contact-default");
      const text = (source ? source.textContent : "").trim();
      if (!text) return;

      // Swap on the gesture, not on the promise. The write resolves in well
      // under a frame, and gating the label on it makes the tap read as
      // unanswered on the one device (mobile) that has no hover to fall back on.
      contact.classList.add("is-copied");
      if (copiedTimer) clearTimeout(copiedTimer); // re-tap restarts the 1.5s
      copiedTimer = setTimeout(() => {
        contact.classList.remove("is-copied");
        copiedTimer = null;
      }, COPIED_MS);

      copyText(text).catch(() => {});
    };

    contact.addEventListener("click", handleCopy);
  }
});
